import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IFollowUpTaskEmail } from "../../utils/types/models";

export default createEntityReducer<IFollowUpTaskEmail>(Endpoint.FollowUpTaskEmails, Endpoint.FollowUpTaskEmailsList);
